import React from "react";
import loadable from "@loadable/component";
import Loading from "../Loading.js";

const LoadableComponent = loadable(() => import("./AddCompleteProfile"), {
  fallback: <Loading />
});

const LoadableCompleteProfile = () => (
  <LoadableComponent />
)

export default LoadableCompleteProfile;
